import { useEffect } from "react";
import { api } from "./api";

// Counts a QR / campaign visit (?src=poster) once per browser session and remembers it for checkout attribution.
export const useScanTracking = (page) => {
    useEffect(() => {
        const src = new URLSearchParams(window.location.search).get("src");
        if (!src) return;
        localStorage.setItem("flex_src", src.slice(0, 30));
        const key = `flex_scan_${src}_${page}`;
        if (sessionStorage.getItem(key)) return;
        sessionStorage.setItem(key, "1");
        api.post("/track/scan", { src, page }).catch(() => {});
    }, [page]);
};
